/*
 * pf-barra-compra.js — PhotoFury, 17/08/2026
 *
 * Barra fija que aparece cuando el boton real de compra sale de pantalla.
 *
 * 🔴🔴 POR QUE LA BARRA *LLEVA* AL BOTON EN VEZ DE AÑADIR AL CARRITO ELLA MISMA
 *
 * La primera version delegaba: su boton hacia `botonReal.click()`. Parecia lo correcto
 * —asi los campos que la app OPTIS mete en el formulario viajarian solos— pero se probo
 * en la Nikon Z50 II con «3 años de garantia (+70 €)» elegido y el resultado fue:
 *
 *     pulsando el boton REAL      -> 934 €  con { " Garantia": "3 años (+ €70,00)", ... }
 *     pulsando el boton de la BARRA -> 864 €  con properties VACIO
 *
 * Tres lecturas del carrito a 2,5 / 5,5 / 8,5 s dieron lo mismo, asi que no es una carrera
 * de tiempos: OPTIS no procesa el clic cuando viene delegado desde otro elemento.
 *
 * Consecuencia si se hubiera dejado asi: el cliente elige 3 años, compra desde la barra y
 * se lleva el producto SIN la garantia que creia haber contratado, y la tienda pierde el
 * recargo. Es exactamente el tipo de fallo que no se ve hasta que llega la reclamacion.
 *
 * Por eso la barra ahora **lleva al cliente al boton de verdad y le pone el foco**. Sigue
 * resolviendo el problema (no hay que buscar el boton en una ficha de 9 pantallas) y no
 * puede perder ninguna opcion. Si algun dia OPTIS deja de usarse, se puede volver a la
 * version que añade directamente.
 */
(function () {
  'use strict';

  function iniciar() {
    var barra = document.querySelector('[data-pf-barra-compra]');
    if (!barra || barra.dataset.pfListo === 'si') return;

    var botonReal =
      document.querySelector('product-form button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[name="add"]');
    if (!botonReal) return;

    barra.dataset.pfListo = 'si';

    var mostrar = function (visible) {
      if (visible === (barra.hidden === false)) return;
      barra.hidden = !visible;
      barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
      barra.classList.toggle('pf-barra-compra--visible', visible);
    };

    var obs = new IntersectionObserver(
      function (entradas) {
        mostrar(!entradas[0].isIntersecting);
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0 }
    );
    obs.observe(botonReal);

    var disparador = barra.querySelector('[data-pf-barra-anadir]');
    if (disparador) {
      disparador.addEventListener('click', function () {
        // Llevar al bloque de compra: asi el cliente ve las opciones (garantia, filtros)
        // antes de pulsar, y pulsa el boton de verdad.
        var destino = botonReal.closest('.product__info-container') || botonReal;
        var suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        destino.scrollIntoView({ behavior: suave, block: 'center' });

        // El foco va al boton real: quien navega con teclado sigue donde toca, y en movil
        // el navegador resalta el destino.
        window.setTimeout(function () {
          botonReal.focus({ preventScroll: true });
        }, suave === 'smooth' ? 520 : 0);
      });
    }

    // El precio de la barra sigue al de la ficha (cantidad, opciones).
    var precio = barra.querySelector('.pf-barra-compra__precio');
    if (precio) {
      var refrescar = function () {
        var vivo = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');
        if (vivo && vivo.textContent.trim()) precio.textContent = vivo.textContent.trim();
      };
      document.addEventListener('change', refrescar);
      document.addEventListener('variant:change', refrescar);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
